import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { CartProvider } from './contexts/CartContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Cart from './components/Cart';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home/Home';
import SearchResults from './pages/SearchResults';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Categories from './pages/Categories';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentSuccess from './pages/PaymentSuccess';
import PlaceholderPage from './pages/PlaceholderPage';
import './i18n';
import './App.css';

function App() {
  return (

    <LanguageProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<SearchResults />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/products/:category" element={<Products />} />
                        <Route path="/product/:id" element={<ProductDetail />} />
                          <Route path="/checkout" element={<Checkout />} />
                          <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
                          <Route path="/payment/success" element={<PaymentSuccess />} />
                          <Route path="/payment-failed" element={<PaymentFailed />} />
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/cart" element={<PlaceholderPage title="Shopping Cart" description="Your cart items will appear here soon!" />} />
              </Routes>
            </main>
            <Footer />
            <Cart />
          </div>
        </Router>
      </CartProvider>
    </LanguageProvider>

  );
}

export default App;
